import type { UseQueryResult } from "@tanstack/react-query";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import type {
    CrmRecordsParams,
    CrmRecordsResponseDto,
} from "app/pages/sales-intelligence/domain/crm-integration/types/records";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { NoCacheHeaders } from "app/services/fetchService";

import { crmIntegrationQueryKeys } from "../key-factory/factory";

const CRM_RECORDS_STALE_TIME_MS = 60 * 60_000; // 1h as data is synced to CRM hourly

export function useCompanyCrmRecordsQuery<T = CrmRecordsResponseDto>(
    params: CrmRecordsParams,
    enabled: boolean,
    select?: (data: CrmRecordsResponseDto) => T,
): UseQueryResult<T> {
    return useQuery({
        // CRM records are live external data — keep a finite staleTime
        staleTime: CRM_RECORDS_STALE_TIME_MS,
        enabled,
        queryKey: crmIntegrationQueryKeys.companyRecords(params),
        placeholderData: keepPreviousData,
        select,
        queryFn: ({ signal }): Promise<CrmRecordsResponseDto> => {
            return salesApiService.crmIntegration.fetchCompanyCrmRecords(params, {
                headers: NoCacheHeaders,
                cancellation: signal,
            });
        },
    });
}
